import React, { useEffect, useState } from "react";
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, Label, Input,
    FormGroup,
    Row,
    Col
} from "reactstrap";
import UserServices from "../services/UserServices";
import RapportServices from "../services/RapportServices";
import PieChart from "../components/PieChart";
import Pagination from "../components/Pagination";
import PolarAreaChart from "../components/PolarAreaChart";
import LineChart from "../components/LineChart";
import BarChart from "../components/BarChart";



const Rapport = () => {
    const [rapports, setRapports] = useState([]);
    const [users, setUsers] = useState([]);

    const [modal, setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const [disableAddButton, setDisableAddButton] = useState(false);
    const [newRapport, setNewRapport] = useState({
        id: null,
        installation: 0,
        interqualite: 0,
        interdepannage: 0,
        visite: 0,
        recuperation: 0,
        autre: "RAS",
        created_at: new Date().toISOString().substring(0, 10),
        id_user: Number(sessionStorage.getItem('id_user'))
    });
    const [editRapport, setEditRapport] = useState({
        id: null,
        installation: 0,
        interqualite: 0,
        interdepannage: 0,
        visite: 0,
        recuperation: 0,
        autre: "RAS",
        created_at: new Date().toISOString().substring(0, 10),
        id_user: Number(sessionStorage.getItem('id_user'))
    });
    const [deleteRapport, setDeleteRapport] = useState(null);
    const [annees, setAnnees] = useState([]);
    const [anneeSelectionnee, setAnneeSelectionnee] = useState(new Date().getFullYear());
    const [moisSelectionne, setMoisSelectionne] = useState('');
    const [filtre, setFiltre] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [chartType, setChartType] = useState('pie');
    const [activeChartType, setActiveChartType] = useState('pie');

    const lastIndex = currentPage * perPage;
    const firstIndex = lastIndex - perPage;
    //const currentRapports = rapports.slice(firstIndex, lastIndex);


    let totalInstallation = 0;
    let totalInterdepannage = 0;
    let totalInterqualite = 0;
    let totalRecuperation = 0;
    let totalVisite = 0;

    useEffect(() => {
        const fetchRapports = async () => {
            const rapports = await RapportServices.getRapport();
            setRapports(rapports.reverse());
        };
        fetchRapports();

        const fetchUsers = async () => {
            const users = await UserServices.getUsers();
            setUsers(users);
        };
        fetchUsers();
    }, []);

    useEffect(() => {
        // Récupération des 10 dernières années pour le champ de sélection des années
        const now = new Date();
        const anneeEnCours = now.getFullYear();
        const annees = Array.from({ length: 10 }, (_, i) => anneeEnCours - i);
        setAnnees(annees);
    }, []);


    function handleFiltreChange(e) {
        setFiltre(e.target.value);
    }

    function handleAnneeSelectionneeChange(e) {
        setAnneeSelectionnee(Number(e.target.value));
    }

    function handleMoisSelectionneChange(e) {
        setMoisSelectionne(e.target.value);
    }

    let currentRapports = [];

    function filtrerRapports() {
        let rapportsFiltres = rapports;

        // Filtrer par année
        if (filtre === 'annee') {
            rapportsFiltres = rapports.filter(rapport => {
                const anneeRapport = new Date(rapport.created_at).getFullYear();
                return anneeRapport === anneeSelectionnee;
            });
        }

        // Filtrer par mois
        if (filtre === 'mois') {
            rapportsFiltres = rapports.filter(rapport => {
                const anneeRapport = new Date(rapport.created_at).getFullYear();
                const moisRapport = new Date(rapport.created_at).getMonth() + 1;
                return anneeRapport === anneeSelectionnee && moisRapport === Number(moisSelectionne);
            });
        }

        // Si aucun filtre n'est sélectionné
        if (!filtre) {
            totalInstallation = rapports.reduce((acc, rapport) => acc + rapport.installation, 0);
            totalInterqualite = rapports.reduce((acc, rapport) => acc + rapport.interqualite, 0);
            totalInterdepannage = rapports.reduce((acc, rapport) => acc + rapport.interdepannage, 0);
            totalRecuperation = rapports.reduce((acc, rapport) => acc + rapport.recuperation, 0);
            totalVisite = rapports.reduce((acc, rapport) => acc + rapport.visite, 0);
        } else {
            // Si un filtre est sélectionné
            totalInstallation = rapportsFiltres.reduce((acc, rapport) => acc + rapport.installation, 0);
            totalInterdepannage = rapportsFiltres.reduce((acc, rapport) => acc + rapport.interdepannage, 0);
            totalInterqualite = rapportsFiltres.reduce((acc, rapport) => acc + rapport.interqualite, 0);
            totalRecuperation = rapportsFiltres.reduce((acc, rapport) => acc + rapport.recuperation, 0);
            totalVisite = rapportsFiltres.reduce((acc, rapport) => acc + rapport.visite, 0);
        }

        return rapportsFiltres;
    }


    currentRapports = filtrerRapports().slice(firstIndex, lastIndex);



    const showRoleTitle = (user_id) => {
        const user = users.find((u) => u.id === user_id);
        return user ? `${user.first_name} ${user.last_name}` : '';
    };

    // Fonction pour vérifier si la colonne "created_at" d'une ligne donnée est égale à la date d'aujourd'hui
    const isToday = (date) => {
        const today = new Date();
        return (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        );
    };

    useEffect(() => {
        // Fonction pour désactiver le bouton "Ajouter un rapport" si la colonne "created_at" d'une ligne donnée est égale à la date d'aujourd'hui
        const checkDateAndDisableButton = (report) => {
            const createdAtDate = new Date(report.created_at);
            if (isToday(createdAtDate)) {
                setDisableAddButton(true);
            }
        };

        rapports.forEach((rapport) => {
            checkDateAndDisableButton(rapport);
        });
    }, [rapports]);

    const PieData = {
        labels: ['Installation', 'Inter-qualité', 'Inter-dépannage', 'Visite', 'Récupération'],
        datasets: [{
            label: '# of Votes',
            data: [totalInstallation, totalInterqualite, totalInterdepannage, totalVisite, totalRecuperation],
            borderWidth: 2,
            backgroundColor: ['#ee6321', '#c3e0db', '#c5a028', '#007bff', '#21eeca']
        }]
    };

    const LineData = {
        labels: ['Installation', 'Inter-qualité', 'Inter-dépannage', 'Visite', 'Récupération'],
        datasets: [{
            label: '# of Votes',
            data: [
                { x: 'Installation', y: totalInstallation },
                { x: 'Inter-qualité', y: totalInterqualite },
                { x: 'Inter-dépannage', y: totalInterdepannage },
                { x: 'Visite', y: totalVisite },
                { x: 'Récupération', y: totalRecuperation }
            ],
            fill: false,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1,
            borderWidth: 2,
            backgroundColor: ['#ee6321', '#c3e0db', '#c5a028', '#007bff', '#21eeca']
        }]
    };

    const BarData = {
        labels: ['Installation', 'Inter-qualité', 'Inter-dépannage', 'Visite', 'Récupération'],
        datasets: [
            {
                label: '# of Votes',
                data: [totalInstallation, totalInterqualite, totalInterdepannage, totalVisite, totalRecuperation],
                backgroundColor: ['#ee6321', '#c3e0db', '#c5a028', '#007bff', '#21eeca'],
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 2,
            },
        ],
    };

    const handleButtonClick = (chartType) => {
        setChartType(chartType);
    };

    const handleChartTypeChange = (chartType) => {
        setActiveChartType(chartType);
        handleButtonClick(chartType);
    };

    let chartComponent = null;
    switch (chartType) {
        case 'pie':
            chartComponent = <PieChart data={PieData} />;
            break;
        case 'polarArea':
            chartComponent = <PolarAreaChart data={PieData} />;
            break;
        case 'line':
            chartComponent = <LineChart data={LineData} />;
            break;
        case 'bar':
            chartComponent = <BarChart data={BarData} />;
            break;
        default:
            chartComponent = <PieChart data={PieData} />;
            break;
    }

    const toggleModal = () => {
        setModal(!modal);
    };

    const toggleEditModal = () => {
        setEditModal(!editModal);
    };

    const toggleDeleteModal = () => {
        setDeleteModal(!deleteModal);
    };

    const handleNewRapportChange = (event) => {
        setNewRapport({ ...newRapport, [event.target.name]: event.target.value });
    };

    const handleEditRapportChange = (event) => {
        setEditRapport({ ...editRapport, [event.target.name]: event.target.value });
    };

    const handleEditButtonClick = (rapport) => {
        const item = {
            id: rapport.id,
            installation: rapport.installation,
            interqualite: rapport.interqualite,
            interdepannage: rapport.interdepannage,
            visite: rapport.visite,
            recuperation: rapport.recuperation,
            autre: rapport.autre,
            created_at: new Date(rapport.created_at).toISOString().substring(0, 10),
            id_user: rapport.id_user
        }
        setEditRapport(item);
        toggleEditModal();
    };

    const validateFields = () => {
        if (
            newRapport.installation === "" ||
            newRapport.interqualite === "" ||
            newRapport.interdepannage === "" ||
            newRapport.recuperation === ""
        ) {
            setAlert("Veuillez remplir tous les champs obligatoires.");
            return false;
        }

        if (newRapport.installation === "") {
            setAlert("L'installation doit être un entier.");
            return false;
        }

        if (newRapport.interqualite === "") {
            setAlert("L'interqualite doit être un entier.");
            return false;
        }

        if (newRapport.interdepannage === "") {
            setAlert("L'interdepannage doit être un entier.");
            return false;
        }

        if (newRapport.visite === "") {
            setAlert("La visite doit être un entier.");
            return false;
        }

        if (newRapport.recuperation === "") {
            setAlert("La recuperation doit être un entier.");
            return false;
        }

        return true;
    };

    const EditValidateFields = () => {

        if (editRapport.installation === "") {
            setAlert("L'installation doit être un entier.");
            return false;
        }

        if (editRapport.interqualite === "") {
            setAlert("L'interqualite doit être un entier.");
            return false;
        }

        if (editRapport.interdepannage === "") {
            setAlert("L'interdepannage doit être un entier.");
            return false;
        }

        if (editRapport.visite === "") {
            setAlert("La visite doit être un entier.");
            return false;
        }

        if (editRapport.recuperation === "") {
            setAlert("La recuperation doit être un entier.");
            return false;
        }

        return true;
    };

    const addRapport = () => {
        const rapport = {
            installation: Number(newRapport.installation),
            interqualite: Number(newRapport.interqualite),
            interdepannage: Number(newRapport.interdepannage),
            visite: Number(newRapport.visite),
            recuperation: Number(newRapport.recuperation),
            autre: newRapport.autre,
            created_at: new Date(newRapport.created_at).toISOString().substring(0, 10),
            id_user: Number(sessionStorage.getItem('id_user'))
        };
        let addedRapport;
        console.log(rapport);
        RapportServices.addRapport(rapport)
            .then(data => {
                console.log(data);
                if (data.status === 201) {
                    addedRapport = data.rapport;
                    addedRapport.id = Number(addedRapport.id);
                    addedRapport.id_user = Number(addedRapport.id_user);
                    setRapports([...rapports, addedRapport].reverse());
                    setNewRapport({
                        id: null,
                        installation: 0,
                        interqualite: 0,
                        interdepannage: 0,
                        visite: 0,
                        recuperation: 0,
                        autre: "RAS",
                        created_at: new Date().toISOString().substring(0, 10),
                        user: ""
                    });
                    toggleModal();
                    setMessage("Rapport ajouté avec succès !");
                    setTimeout(() => {
                        setMessage("");
                    }, 2000);
                } else {
                    let message = "";
                    if (Array.isArray(data.message)) {
                        message = data.message.join(", ");
                    } else {
                        message = data.message;
                    }
                    setAlert(message);
                    setTimeout(() => {
                        setAlert("");
                    }, 5000);

                }
            })
            .catch(error => console.error(error));
    };

    const handleAddRapport = () => {
        if (validateFields()) {
            addRapport();
        }
    };


    const handleEditRapport = () => {
        if (!EditValidateFields()) {
            return;
        }

        let updatedRapport;
        editRapport.id_user = Number(sessionStorage.getItem('id_user'));
        console.log(editRapport);
        RapportServices.updateRapport(editRapport)
            .then(data => {
                console.log(data);
                if (data.status === 201) {
                    updatedRapport = data.rapport;
                    updatedRapport.id_user = Number(updatedRapport.id_user);

                    const updatedRapports = rapports.map(rapport => rapport.id === updatedRapport.id ? updatedRapport : rapport);
                    setRapports(updatedRapports);

                    setEditRapport({
                        id: null,
                        installation: 0,
                        interqualite: 0,
                        interdepannage: 0,
                        visite: 0,
                        recuperation: 0,
                        autre: "RAS",
                        created_at: new Date().toISOString().substring(0, 10),
                        id_user: Number(sessionStorage.getItem('id_user'))
                    });
                    toggleEditModal();
                    setMessage("Modification effectuée avec succès !");
                    setTimeout(() => {
                        setMessage("");
                    }, 2000);
                } else {
                    let message = "";
                    if (Array.isArray(data.message)) {
                        message = data.message.join(", ");
                    } else {
                        message = data.message;
                    }
                    setAlert(message);
                    setTimeout(() => {
                        setAlert("");
                    }, 5000);

                }
            })
            .catch(error => console.error(error));
    };


    const handleDeleteRapport = () => {
        RapportServices.deleteRapport(deleteRapport)
            .then(data => {
                const createdAtDate = new Date(deleteRapport.created_at);
                const remainingRapports = rapports.filter((r) => r.id !== deleteRapport.id);
                setRapports(remainingRapports);
                setDeleteRapport(null);
                toggleDeleteModal();
                setMessage("Rapport supprimé avec succès !");
                if (isToday(createdAtDate)) {
                    setDisableAddButton(false);
                }
                setTimeout(() => {
                    setMessage("");
                }, 2000);
            })
            .catch(error => console.error(error));
    };

    return (
        <div className="m-5">
            <h1 className='mb-5'>Liste des Rapports</h1>
            <hr />
            {message && <div className="alert alert-success">{message}</div>}
            <div className="row">
                <div className="col-md-4">
                    <div className="btn-group d-flex" role="group" aria-label="Chart type selection">
                        <button type="button" className={`btn btn-primary ${activeChartType === 'pie' ? 'active' : ''}`} onClick={() => handleChartTypeChange('pie')}>Pie Chart</button>
                        <button type="button" className={`btn btn-primary ${activeChartType === 'polarArea' ? 'active' : ''}`} onClick={() => handleChartTypeChange('polarArea')}>Polar Area Chart</button>
                        <button type="button" className={`btn btn-primary ${activeChartType === 'line' ? 'active' : ''}`} onClick={() => handleChartTypeChange('line')}>Line Chart</button>
                        <button type="button" className={`btn btn-primary ${activeChartType === 'bar' ? 'active' : ''}`} onClick={() => handleChartTypeChange('bar')}>Bar Chart</button>
                    </div>
                    {chartComponent}
                </div>
                <div className="col-md-8">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="filtre-select">Filtrer par :</label>
                                <select id="filtre-select" className="form-control" value={filtre} onChange={handleFiltreChange}>
                                    <option value="">Tous les rapports</option>
                                    <option value="annee">Par année</option>
                                    <option value="mois">Par mois</option>
                                </select>
                            </div>

                            {(filtre === 'annee' || filtre === 'mois') &&
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="annee-select">Année :</label>
                                            <select id="annee-select" className="form-control" value={anneeSelectionnee} onChange={handleAnneeSelectionneeChange}>
                                                {annees.map(annee =>
                                                    <option key={annee} value={annee}>{annee}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    {filtre === 'mois' &&
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="mois-select">Mois :</label>
                                                <select id="mois-select" className="form-control" value={moisSelectionne} onChange={handleMoisSelectionneChange}>
                                                    <option value="">Tous les mois</option>
                                                    <option value="1">Janvier</option>
                                                    <option value="2">Février</option>
                                                    <option value="3">Mars</option>
                                                    <option value="4">Avril</option>
                                                    <option value="5">Mai</option>
                                                    <option value="6">Juin</option>
                                                    <option value="7">Juillet</option>
                                                    <option value="8">Août</option>
                                                    <option value="9">Septembre</option>
                                                    <option value="10">Octobre</option>
                                                    <option value="11">Novembre</option>
                                                    <option value="12">Décembre</option>
                                                </select>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>

                    </div>
                    <button
                        className="my-4 btn btn-success"
                        onClick={toggleModal}
                        disabled={disableAddButton}
                    >
                        Ajouter un rapport
                    </button>
                    <table className="table table-striped align-middle text-center table-bordered table-hover table-sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Installation</th>
                                <th>Interqualite</th>
                                <th>Interdepannage</th>
                                <th>Visite</th>
                                <th>Récuperation</th>
                                <th>Autre</th>
                                <th>Création le</th>
                                <th>Utilisateur</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rapports ? (
                                currentRapports.map((rapport, index) => (
                                    <tr key={rapport.id}>
                                        <td>{index + 1}</td>
                                        <td>{rapport.installation}</td>
                                        <td>{rapport.interqualite}</td>
                                        <td>{rapport.interdepannage}</td>
                                        <td>{rapport.visite}</td>
                                        <td>{rapport.recuperation}</td>
                                        <td>{rapport.autre}</td>
                                        <td>{new Date(rapport.created_at).toLocaleDateString()}</td>
                                        {showRoleTitle(rapport.id_user) ? (
                                            <td>{showRoleTitle(rapport.id_user)}</td>
                                        ) : (
                                            <td>
                                                {sessionStorage.getItem('first_name')} {' '}
                                                {sessionStorage.getItem('last_name')}
                                            </td>
                                        )}
                                        <td>
                                            <div className="btn-group btn-group-sm" role="group" aria-label="Actions">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => handleEditButtonClick(rapport)}
                                                >
                                                    <i className="fa-solid fa-pencil"></i>
                                                </button>

                                                <button type="button" className="btn btn-sm btn-danger" onClick={() => {
                                                    setDeleteRapport(rapport);
                                                    toggleDeleteModal();
                                                }}>
                                                    <i className="fa-solid fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colspan="10">Aucun enregistrement trouvé</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {rapports && <Pagination
                        totalRapports={rapports.length}
                        perPage={perPage}
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage} />}

                    <Modal isOpen={modal} toggle={toggleModal} className="modal-dialog modal-lg">
                        <ModalHeader toggle={toggleModal}>Ajouter un rapport</ModalHeader>
                        <ModalBody>
                            {alert && <div className="alert alert-danger">{alert}</div>}
                            <Form>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="installation">Installation *</Label>
                                            <Input
                                                type="number"
                                                name="installation"
                                                id="installation"
                                                value={newRapport.installation || ''}
                                                onChange={handleNewRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="interqualite">Interqualite *</Label>
                                            <Input
                                                type="number"
                                                name="interqualite"
                                                id="interqualite"
                                                value={newRapport.interqualite || ''}
                                                onChange={handleNewRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="interdepannage">Interdepannage *</Label>
                                            <Input
                                                type="number"
                                                name="interdepannage"
                                                id="interdepannage"
                                                value={newRapport.interdepannage || ''}
                                                onChange={handleNewRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="visite">Visite *</Label>
                                            <Input
                                                type="number"
                                                name="visite"
                                                id="visite"
                                                value={newRapport.visite || ''}
                                                onChange={handleNewRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="recuperation">Récuperation *</Label>
                                            <Input
                                                type="number"
                                                name="recuperation"
                                                id="recuperation"
                                                value={newRapport.recuperation || ''}
                                                onChange={handleNewRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="autre">Autre </Label>
                                            <Input
                                                type="text"
                                                name="autre"
                                                id="autre"
                                                value={newRapport.autre || ''}
                                                onChange={handleNewRapportChange}
                                                required={false}
                                                placeholder="Autre information"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="created_at">Date de création *</Label>
                                            <Input
                                                type="date"
                                                name="created_at"
                                                id="created_at"
                                                value={newRapport.created_at || ''}
                                                onChange={handleNewRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4"></Col>
                                    <Col md="4"></Col>
                                </Row>
                            </Form>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleAddRapport}>
                                Ajouter
                            </Button>{" "}
                            <Button color="secondary" onClick={toggleModal}>
                                Annuler
                            </Button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={editModal} toggle={toggleEditModal} className="modal-dialog modal-lg">
                        <ModalHeader toggle={toggleEditModal}>Modifier le rapport</ModalHeader>
                        <ModalBody>
                            {alert && <div className="alert alert-danger">{alert}</div>}
                            <Form>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="installation">Installation *</Label>
                                            <Input
                                                type="number"
                                                name="installation"
                                                id="installation"
                                                value={editRapport.installation || ''}
                                                onChange={handleEditRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="interqualite">Interqualite *</Label>
                                            <Input
                                                type="number"
                                                name="interqualite"
                                                id="interqualite"
                                                value={editRapport.interqualite || ''}
                                                onChange={handleEditRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="interdepannage">Interdepannage *</Label>
                                            <Input
                                                type="number"
                                                name="interdepannage"
                                                id="interdepannage"
                                                value={editRapport.interdepannage || ''}
                                                onChange={handleEditRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="visite">Visite *</Label>
                                            <Input
                                                type="number"
                                                name="visite"
                                                id="visite"
                                                value={editRapport.visite || ''}
                                                onChange={handleEditRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="recuperation">Récuperation *</Label>
                                            <Input
                                                type="number"
                                                name="recuperation"
                                                id="recuperation"
                                                value={editRapport.recuperation || ''}
                                                onChange={handleEditRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="autre">Autre </Label>
                                            <Input
                                                type="text"
                                                name="autre"
                                                id="autre"
                                                value={editRapport.autre || ''}
                                                onChange={handleEditRapportChange}
                                                required={false}
                                                placeholder="Autre information"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="4">
                                        <FormGroup>
                                            <Label for="created_at">Date de création *</Label>
                                            <Input
                                                type="date"
                                                name="created_at"
                                                id="created_at"
                                                value={editRapport.created_at || ''}
                                                onChange={handleEditRapportChange}
                                                required={true}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4"></Col>
                                    <Col md="4"></Col>
                                </Row>
                            </Form>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleEditRapport}>
                                Modifier
                            </Button>{" "}
                            <Button color="secondary" onClick={toggleEditModal}>
                                Annuler
                            </Button>
                        </ModalFooter>
                    </Modal>

                    <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
                        <ModalHeader toggle={toggleDeleteModal}>Supprimer le rapport</ModalHeader>
                        <ModalBody>
                            Êtes-vous sûr de vouloir supprimer cet rapport ?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={handleDeleteRapport}>
                                Supprimer
                            </Button>{" "}
                            <Button color="secondary" onClick={toggleDeleteModal}>
                                Annuler
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default Rapport;
